import './App.css';
import React from 'react';
import PlayerContainer from './PlayerContainer';
import { kalturaServices } from '../services/kaltura';
import { rocketServices } from '../services/rocket';
import { getUrlParameter } from '../helpers';

class App extends React.Component {
  state = { ks: '', mediaID: '' };

  componentDidMount() {
    this.getKSToken();
    this.getMediaID();
  }

  getKSToken = async () => {
    const response = await kalturaServices.getKS();
    this.setState({ ks: response.data.result.ks });
  };

  getMediaID = async () => {
    let mediaID;

    const axisId = getUrlParameter('id');
    if (axisId) {
      try {
        const response = await rocketServices.getKalturaId(axisId);
        if (response.status === 200 && response.data) {
          mediaID = response.data.customId;
        }
      } catch (e) {
        mediaID = 'na';
      }
    } else {
      mediaID =
        getUrlParameter('mediaid') ||
        getUrlParameter('mediaId') ||
        getUrlParameter('media-id');
    }

    this.setState({
      mediaID,
    });
  };

  render() {
    const { ks, mediaID } = this.state;
    return (
      <>{ks && mediaID && <PlayerContainer mediaID={mediaID} ks={ks} />}</>
    );
  }
}

export default App;
